// extracted by mini-css-extract-plugin
module.exports = {"ratingItem":"RateStar_ratingItem__C2xZV","ratingStar":"RateStar_ratingStar__4KYZp","ratingHalf":"RateStar_ratingHalf__ayxd1","title":"RateStar_title__4V7Iv"};